"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this is important so that the app doesn't crash on the import of this function
const reportError = (error) => {
    return error;
};
exports.default = reportError;
